import type {
  Props as BreadcrumbProps,
} from '@sgcmpteltd/uikit-react/components/breadcrumb';
import {
  BREADCRUMB_TYPE_LINK,
  BREADCRUMB_TYPE_TEXT,
} from '@sgcmpteltd/uikit-react/components/breadcrumb';

import { joinSgcmSite } from '@/utils/url/join/public';

export const breadcrumbList: BreadcrumbProps['list'] = [
  {
    key: 'home',
    type: BREADCRUMB_TYPE_LINK,
    href: '/',
    text: 'Home',
  },
  {
    key: 'newCarsHome',
    type: BREADCRUMB_TYPE_LINK,
    href: joinSgcmSite('new_cars/index.php').toString(),
    text: 'New Cars',
  },
  {
    key: 'newCarPromotions',
    type: BREADCRUMB_TYPE_TEXT,
    text: 'New Car Promotions',
  },
];
